// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ZapierApiKeyRepositoryService extends BaseRepositoryService<
  ModelRegistry['zapier-api-key']
> {
  recordName = 'zapier-api-key';
  implementMethods = ['findAll', 'createRecord'];

  public async getDefaultRecord(): Promise<
    DS.PromiseObject<ModelRegistry['zapier-api-key']>
  > {
    const data = await this.findAll();

    return data[0] || this.createRecord();
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/zapier-api-key': ZapierApiKeyRepositoryService;
  }
}
